import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import { useState } from 'react';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import SelectML from '@/components/select_ml/SelectML';
import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';
import ButtonML from '@/components/button_ml/ButtonML';
import { history } from 'umi';

const SearchGroup = (props) => {
  const { options, addOptions, editableGetFecth } = props;
  // const { editable } = props.location.query;
  const [showAdd, setShowAdd] = useState(false);
  const [filedName, setFiledName] = useState('');
  const [form] = Form.useForm();

  const onFinish = () => {
    props.handleSearch({ id: filedName });
  };

  const onChange = (e) => {
    setFiledName(e);
  };

  const onAdd = (e) => {
    if (!e.fieldIds) {
      setShowAdd(true);
    } else {
      props.onAdd(e);
    }
  };
  return (
    <div className={styles.searchGroupBox}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 字段名称 */}
          <SelectML
            height="37px"
            labelwidth="130px"
            labelVal="字段名称"
            placeVal="所有字段"
            name="id"
            allowClear={true}
            option={options}
            onChange={onChange}
          />
        </div>

        <div className={styles.btn_contain}>
          <ButtonML
            size="large"
            value="查询"
            fontsize="16px"
            onClick={onFinish}
          />
          {/* <ButtonML size="large" value="新增" fontsize="16px" onClick={onAdd} /> */}
        </div>
      </Form>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onAdd}
        className={styles.serarchFrom}
      >
        <div
          className={styles.input_contain_add}
          style={{ width: showAdd ? '250px' : '0px' }}
        >
          <Cascader height="37px" name="fieldIds" options={addOptions} />
        </div>

        <div className={styles.btn_contain}>
          <ButtonML
            size="large"
            value="新增"
            htmlType="submit"
            fontsize="16px"
            disabled={String(editableGetFecth) === 'false'}
          />
        </div>
        <ButtonML
          size="large"
          value="返回"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={() => history.go(-1)}
        />
      </Form>
    </div>
  );
};

export default SearchGroup;
